import Swiper from "swiper"
import Vue from "vue"
import PublicPriceCalculator from "@components/PublicPricing/PublicPriceCalculator.vue"

if (document.querySelector(".pricing-landing__cases_slider")) {
    var casesSlider = new Swiper(".pricing-landing__cases_slider", {
        autoplay: {
            delay: "3000",
            disableOnInteraction: true
        },
        autoHeight: true,
        slidesPerView: 1,
        navigation: {
            nextEl: ".pricing-landing__cases_slider__navigation_next",
            prevEl: ".pricing-landing__cases_slider__navigation_prev"
        },
        pagination: {
            el: ".pricing-landing__cases_slider-item__pagination",
            type: "bullets",
            clickable: true
        },
        loop: true
    })
    if (casesSlider) {
        let casesSliderBySelector = document.querySelector(".pricing-landing__cases_slider")
        casesSliderBySelector.onmouseover = function () {
            casesSlider.autoplay.stop()
        }
        casesSliderBySelector.onmouseleave = function () {
            casesSlider.autoplay.start()
        }
    }
    let nextCaseButtons = document.querySelectorAll(".pricing-landing__cases_slider-item__next-case")
    for (let i = 0; i < nextCaseButtons.length; i++) {
        let item = nextCaseButtons[i]

        item.addEventListener("click", () => {
            casesSlider.slideNext()
        })
    }
    let casesSliderPagination = document.querySelectorAll(".pricing-landing__cases_pagination-item")
    for (let i = 0; i < casesSliderPagination.length; i++) {
        let item = casesSliderPagination[i]

        item.addEventListener("click", () => {
            let slideIndex = item.dataset.casesStart

            casesSlider.slideToLoop(+slideIndex)
            casesSlider.autoplay.start()
        })
    }

    setActivePagination(casesSlider.realIndex, casesSliderPagination)

    casesSlider.on("slideChange", function () {
        setActivePagination(casesSlider.realIndex, casesSliderPagination)
    })
}
function setActivePagination(slideIndex, paginations) {
    paginations.forEach(item => {
        let start = item.dataset.casesStart
        let end = item.dataset.casesEnd
        item.classList.remove("active")
        if (slideIndex >= start && slideIndex <= end) {
            item.classList.add("active")
        }
    })
}
if (document.querySelector(".pricing-landing__pricing__details_block_item_more")) {
    let morePricingButton = document.querySelectorAll(".pricing-landing__pricing__details_block_item_more")

    for (let i = 0; i < morePricingButton.length; i++) {
        let item = morePricingButton[i]

        item.addEventListener("click", () => {
            item.closest(".pricing-landing__pricing__details").classList.toggle("open-price-table")
        })
    }
}

window.scrollToView = function (target, selector) {
    const element = document.querySelector(selector)
    const header = document.querySelector("header")
    const y = element.getBoundingClientRect().top + window.scrollY - header.offsetHeight
    window.scrollTo({ top: y, behavior: "smooth" })
}
if (document.getElementById("public-price-calculator")) {
    new Vue({
        el: "#public-price-calculator",
        components: {
            PublicPriceCalculator
        }
    })
}
